export default __webpack_public_path__ + "static/media/pen-to-square-solid.8d26df12.svg";